import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageCustomerLegalForm } from '../model/page-log-historique';

@Injectable({
    providedIn: 'root'
  })
  export class LogHistoriqueService{
  
    constructor(private _restClientService : RestClientService) { }
    
    getPageLogHistorique(filter, page, size, sortColomun, descending)
    {
        return this._restClientService.load<PageCustomerLegalForm>('log-historique/find-all-pageable'+
        '?filter='+filter+
        '&page='+page+
        '&size='+size+
        '&sortColomun='+sortColomun+
        '&descending='+descending
        );
    }

}      

    